export default __webpack_public_path__ + "static/media/ai_sele.f14b53b2.svg";